import React, { useState, useEffect } from "react";

import Corpo from "../components/Corpo";

import ImgPerfilVazio from "../assets/img/perfil.jpg";

import { getUserSession, findStatisticMultiplayer } from "../services/user-service";

export default function Profile(props) {
  const [user, setUser] = useState({});
  const [statisticMultiplayer, setStatisticMultiplayer] = useState({});

  useEffect(() => {
    const abortController = new AbortController();

    getUserSession().then((res) => {
      setUser(res.data);
    });

    findStatisticMultiplayer().then((res) => {
      setStatisticMultiplayer(res.data);
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-perfil pane pane-game">
          <div
            className="scroll-content ionic-scroll  has-tabs-top"
            style={{ top: "56px" }}
          >
            <div className="scroll">
              <h2>Perfil</h2>
              <div className="perfil-user">
                <img
                  alt="img perfil"
                  src={
                    user.urlAvatar ? user.urlAvatar : ImgPerfilVazio
                  }
                />
                <h3>{user.nome}</h3>
              </div>
              <div className="perfil-placar">
                <div className="row row-center">
                  <div className="col">
                    <h4>
                      {statisticMultiplayer.vitorias || 0}
                      <span>Vitórias</span>
                    </h4>
                  </div>
                  <div className="col">
                    <p>
                      <span>
                        {statisticMultiplayer.vitorias + statisticMultiplayer.derrotas || ""}
                      </span>
                      <span>Partidas</span>
                      <span>Multiplayer</span>
                    </p>
                  </div>
                  <div className="col">
                    <h4>
                      {statisticMultiplayer.derrotas || 0}
                      <span>Derrotas</span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="perfil-placar-singleplayer">
                <h4>
                  <span>{user.qtdPontos}</span>
                  Pontos Singleplayer
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
